"use client"

import { ListingCard } from "@/components/marketing/content/listing-card"
import { ListingGrid } from "@/components/marketing/content/listing-grid"
import { ListingPagination } from "@/components/marketing/content/listing-pagination"
import { track } from "@/lib/analytics/track"
import { LISTING_PAGE_SIZE } from "@/lib/marketing/pagination"

interface AlternativeCard {
  slug: string
  title: string
  description: string
  category?: string
  logoUrl?: string
}

const BASE_PATH = "/alternatives"

export function AlternativesListing({
  alternatives,
  page,
  totalPages,
}: {
  alternatives: AlternativeCard[]
  page: number
  totalPages: number
}) {
  return (
    <>
      {alternatives.length > 0 ? (
        <ListingGrid>
          {alternatives.map((alt, index) => (
            <ListingCard
              key={alt.slug}
              href={`/alternatives/${alt.slug}`}
              title={alt.title}
              description={alt.description}
              category={alt.category}
              logo={alt.logoUrl}
              onClick={() =>
                track("alternatives_card_click", {
                  slug: alt.slug,
                  position: (page - 1) * LISTING_PAGE_SIZE + index + 1,
                })
              }
            />
          ))}
        </ListingGrid>
      ) : (
        <div className="py-16 text-center">
          <p className="text-lg text-muted-foreground">No alternatives yet.</p>
        </div>
      )}

      <ListingPagination basePath={BASE_PATH} page={page} totalPages={totalPages} />
    </>
  )
}
